export default {
  ROUTES: {
    HOME: 'elearning-overview',
    TRAINING: 'elearning-training',
    TRAINING_RESULT: 'elearning-training-result',
    EXAM: 'elearning-exam',
    EXAM_RESULT: 'elearning-exam-result',
  },
  STATUS: { starting: 'starting', canceled: 'canceled', finished: 'finished' },

  LOCAL_STORAGE_KEY: 'elearning.userAnswersByQuestionId',
};
